import React from "react";

const Icon = ({ icon, selectedLocale, marginBottom }) => {
  return (
    <div
      style={
        selectedLocale
          ? { transform: "scaleX(-1)", marginBottom: marginBottom }
          : { marginBottom: marginBottom }
      }
    >
      {icon}
    </div>
  );
};

export default Icon;
